export const version = 'v2.84.0-2-ge02b5667';
